import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from "react-redux";
import store from "./store";
import { captureAttributionFromUrl } from './utils/attribution';

// Attribution capture — parse utm_* off the landing URL once and stash in
// localStorage so it survives route changes and the email-verification
// round-trip. Used at signup to set users.referrer_source on the backend.
captureAttributionFromUrl();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);


root.render(
  <React.StrictMode>
    <Provider store={store}>

    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
      <App />
    </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>,
);
reportWebVitals();
